import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import TxtBox from "../../Custom/TxtBox";
import UiDialog from "../../../components/Custom/UiDialog";
import RadioBtn from "../../../components/Custom/RadioBtn";
import Btn from "../../../components/Custom/Btn";
import SwitchBtn from "../../../components/Custom/SwitchBtn";
import AutoComplete from "../../../components/Custom/AutoComplete";
import Loader from "../../../components/Custom/Loader";
import ExcelGrid from "../../../components/Custom/ExcelGrid";

import { NOTIFY } from "../../../common/config";
import { COLORS } from "../../../common/colors";
import { DEFAULTS } from "../../../common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
} from "../../../common/lables";
import { COMMON_JS } from "../../../common/scripts";
import TxtRow from "../../../components/Custom/TxtRow";

import { PRODUCT_APIs } from "../../../apihandlers/product";

const Box = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [countries, setCounteries] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [products, setProducts] = useState<any>(null);
  const [grams, setGrams] = useState<any>(null);
  const [taxes, setTaxes] = useState<any>(null);

  const productRef: any = useRef(null);

  const gramsRef: any = useRef(null);
  const taxRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getProducts();
    }
  }, [loading]);

  const getProducts = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getProducts(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.productName,
          };
        });
        setProducts(list);
        getGrams();
      }
    });
  };
  const getGrams = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getGramsMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setGrams(list);
        getTax();
      }
    });
  };
  const getTax = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };
    PRODUCT_APIs.getTaxMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.taxName,
          };
        });
        setTaxes(list);
        getRows();
      }
    });
  };
  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await PRODUCT_APIs.getProductsSku(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);

        console.log("Rows List :", list);
      }
    } catch (error) {
      console.error("getCurrencies:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log(selectedRow);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
    },
    {
      key: "productName",
      name: LABELS.SKU_NAME,
      width: "30%",
    },
    {
      key: "grams",
      sortable: true,
      name: LABELS.GRAMS,
      width: "20%",
    },
    {
      key: "taxStructure",
      name: LABELS.TAX,
      width: "15%",
    },
    {
      key: "price",
      name: LABELS.PRICE,
      width: "15%",
    },

    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "10%",
    },

    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const manageBox = () => {
    const productId = productRef.current.selectedValue.id;
    const productName = (
      document.getElementById("skuName") as HTMLInputElement
    ).value.trim();

    const aliasName = (
      document.getElementById("alias") as HTMLInputElement
    ).value.trim();

    const gramsId = gramsRef.current.selectedValue.id;
    const taxStructureId = taxRef.current.selectedValue.id;
    const hsnCode = (
      document.getElementById("hsnCode") as HTMLInputElement
    ).value.trim();
    const mrp = (
      document.getElementById("mrp") as HTMLInputElement
    ).value.trim();
    const price = (
      document.getElementById("price") as HTMLInputElement
    ).value.trim();
    const minPrice = (
      document.getElementById("minPrice") as HTMLInputElement
    ).value.trim();

    const sortingOrder = (
      document.getElementById("sortingOrder") as HTMLInputElement
    ).value.trim();

    let op = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = op ? op.value : "";
    // Validations
    if (!productId) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!productName) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }

    if (!aliasName) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }

    if (!gramsId) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!taxStructureId) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!price) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!mrp) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    if (!sortingOrder) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      productName,
      aliasName,
      branchId: 7,
      gramsId,
      productId,
      taxStructureId,
      price,
      mrp: mrp,
      minPrice,
      sortingOrder,
      hsnCode,
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    PRODUCT_APIs.manageProductSku(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);

        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.BOX}</li>
        </ul>
        <h4>{TITLES.BOX}</h4>
        {/* <p>{SUB_TITLES.CURRENCY}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.BOX}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.BOX + ": " + selectedRow.productName
              : "Add New " + LABELS.BOX
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup ">
            <label>
              {LABELS.PRODUCT_INSIDE}
              {<span className="red">*</span>}
            </label>
            <AutoComplete
              list={products}
              childRef={productRef}
              defaultValue={
                selectedRow.id
                  ? {
                      id: selectedRow.mainProductId,
                      label: selectedRow.mainProduct,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"skuName"}
              type={"text"}
              label={LABELS.SKU_NAME}
              required={true}
              defaultValue={selectedRow.productName}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup">
            <TxtRow
              id={"alias"}
              type={"text"}
              label={LABELS.ALIAS}
              required={true}
              defaultValue={selectedRow.aliasName}
              disabled={isSubmit}
            />
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45 ">
              <label>
                {LABELS.GRAMS}
                {<span className="red">*</span>}
              </label>
              <AutoComplete
                list={grams}
                childRef={gramsRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.gramId,
                        label: selectedRow.grams,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup width45 ">
              <label>
                {LABELS.TAX}
                {<span className="red">*</span>}
              </label>
              <AutoComplete
                list={taxes}
                childRef={taxRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.taxId,
                        label: selectedRow.taxStructure,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width45 ">
              <TxtRow
                id={"hsnCode"}
                type={"text"}
                label={LABELS.HSN_CODE}
                defaultValue={selectedRow.hsnCode}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width45 ">
              <TxtRow
                id={"mrp"}
                type={"number"}
                label={LABELS.MRP}
                required={true}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.mrp).toString()
                    : selectedRow.mrp
                }
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45 ">
              <TxtRow
                id={"price"}
                type={"number"}
                label={LABELS.PRICE}
                required={true}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.price).toString()
                    : selectedRow.price
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width45 ">
              <TxtRow
                id={"minPrice"}
                type={"number"}
                label={LABELS.MIN_PRICE}
                defaultValue={
                  selectedRow.id
                    ? Number(selectedRow.minPrice).toString()
                    : selectedRow.minPrice
                }
                disabled={isSubmit}
              />
            </div>
          </div>
          <div className="flexRowJustify">
            <div className="formGroup width45">
              <TxtRow
                id={"sortingOrder"}
                type={"number"}
                label={LABELS.SORTING_ORDER}
                required={true}
                defaultValue={
                  selectedRow
                    ? Number(selectedRow.sortingOrder).toString()
                    : selectedRow.sortOrder
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width45"></div>
          </div>
          <div className="formGroup">
            <label>{LABELS.STATUS}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup submitBtnWrapper">
            <div className="width45 flexRowJustify">
              <Btn text={LABELS.SAVE} loading={isSubmit} onClick={manageBox} />
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => setManageDialog(false)}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Box);
